import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import {
    Modal,
    Typography,
    List,
    Select,
    Button,
    Popconfirm,
    Popover,
    Drawer,
    Space,
    Checkbox,
    Input,
    Col,
    notification,
    message,
    Row
} from "antd";
import "../../../style/styleComp"
import { HashLoader } from "react-spinners";
import { fetchPDDMaster } from "../../../../../redux/slice/getPDDMaster";
import { fetchTrackingDetails } from "../../../../../redux/slice/getPDDData";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../../context/AuthContext";
import { MyStyledTable, StyledTable, MyDetailedStyledTable, MyDetailedStyledTempTable } from "../../../style/styleComp";
import {
    CheckCircleFilled,
    ExclamationCircleOutlined,
    InfoCircleOutlined,
    PlusOutlined,
    DeleteOutlined,
    SaveOutlined,
} from "@ant-design/icons";
import { RxCrossCircled } from "react-icons/rx";
import { IoIosArrowDropup } from "react-icons/io";
import { IoIosArrowDropdown } from "react-icons/io";
import { markAppIdRecieve, postStampNo, addAdditionalDocuments } from '../../../../../redux/slice/pddAddMissingDocs'
import truckAnimation from "../../../lotties/loaderTruck.json";
import Lottie from "lottie-react";
import {
    fetchPDDAppID,
    fetchNotAddedAppID,
    fetchRegisteredApplications 
} from "../../../../../redux/slice/getPDDAppID";
import { deleteAppId, updateInTransit, updateHoAppId } from "../../../../../redux/slice/pddUpdateIntransitEntry";

const { Text, Title, View } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const AfterReceivedHo = ({
    visible,
    onClose,
    data,
    // all_app_id,
    missing_docs,
    onMissingDocs,
    statusDetails,
    myLoading,
    // app_id,
    branchId 
}) => {


    if (!data ) {
        return null;
    }

    const dispatch = useDispatch();
    const { authState } = useAuth();
    const [loading, setLoading] = useState(false);
    const [selectedValues, setSelectedValues] = useState({});
    const [selectedRows, setSelectedRows] = useState({});
    const [isModified, setIsModified] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [appStatus, setAppStatus] = useState({});
    const [receivedAppIds, setReceivedAppIds] = useState([]);
    const [notReceivedAppIds, setNotReceivedAppIds] = useState([]);
    const [applicationsData, setApplicationsData] = useState([]);
    const [appIdStatus, setAppIdStatus] = useState('');
    const [stampNos, setStampNos] = useState({});
    const [isInputVisible, setIsInputVisible] = useState(false);
    const [documentName, setDocumentName] = useState("");
    const [stampNoChanged, setStampNoChanged] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [currentRecord, setCurrentRecord] = useState(null);
    const [selectedAppIds, setSelectedAppIds] = useState([]);
    const [selectedAppId, setSelectedAppId] = useState(null);
    const [myAppIdArr, setMyAppIdArr] = useState([]);
    const [loadingSave, setLoadingSave] = useState(false);
    const [applicationsLoading, setApplicationsLoading] = useState(false);
const [allAppIdData, setAllAppIdData] = useState([]);
const [availableAppIDs, setAvailableAppIDs] = useState([]);
const [selectOptionsLoaded, setSelectOptionsLoaded] = useState(false);
const [productFilter, setProductFilter] = useState(null);

    const jwtBearer = authState.token;
    const tableRef = useRef(null);

    const masterData = useSelector(
        (state) => state.fetchPDDMaster?.data?.message || []
    );

    // Initialize data from API response
    useEffect(() => {
        if (!data.application_ids) return;

        const initialAppIds = data.application_ids;
        setReceivedAppIds(initialAppIds);
        setNotReceivedAppIds([]);

        // Use applications array from API
        setDataSource(data.applications || []);

        const initialAppStatus = initialAppIds.reduce((acc, appId) => {
            acc[appId] = 'Yes';
            return acc;
        }, {});
        setAppStatus(initialAppStatus);
        setAppIdStatus(data.app_id_status);
    }, [data]);

    const fetchData = () => {
        setLoading(true);
        dispatch(fetchPDDMaster({ jwtBearer }))
            .then(() => setLoading(false))
            .catch((error) => {
                console.error("Error fetching PDD master data:", error);
                setLoading(false);
            });
    };

    // Function to fetch applications when dropdown is clicked
const handleDropdownOpen = async (open) => {
    if (open && !selectOptionsLoaded && branchId && appIdStatus === '1') {
        setApplicationsLoading(true);
        try {
            const response = await dispatch(fetchRegisteredApplications({ 
                jwtBearer, 
                branchId 
            }));
            
            if (response?.type === 'fetchRegisteredApplications/fulfilled') {
                const result = response.payload;
                setAllAppIdData(result.applications || []);
                
                // Filter available App IDs for this branch
                const filtered = result.applications?.filter(app => 
                    app.BR_CD === data.branch && !data.application_ids.includes(app.APP_ID)
                ) || [];
                setAvailableAppIDs(filtered);
                setSelectOptionsLoaded(true);
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Failed to fetch applications',
                    placement: 'bottomRight'
                });
            }
        } catch (error) {
            console.error('Error fetching applications:', error);
            notification.error({
                message: 'Error',
                description: 'Failed to load applications',
                placement: 'bottomRight'
            });
        } finally {
            setApplicationsLoading(false);
        }
    }
};

    const refreshTrackingDetails = async () => {
        await dispatch(fetchTrackingDetails({ jwtBearer, tracking_number: data.tracking_number }));
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    const checklistPLUSEC = useMemo(() => {
        const usecData = masterData.find((item) => item.field === "usec_docs");
        return usecData ? usecData.value : [];
    }, [masterData]);

    const checklistPLSEC = useMemo(() => {
        const secData = masterData.find((item) => item.field === "sec_docs");
        return secData ? secData.value : [];
    }, [masterData]);

    // Initialize selected values from missing_docs
    useEffect(() => {
        if (!data.applications || !missing_docs) return;

        const initialSelectedValues = {};
        const initialSelectedRows = {};

        data.applications.forEach((app) => {
            const checklist = app.product === "PL-USEC" ? checklistPLUSEC : checklistPLSEC;
            initialSelectedValues[app.application_id] = {};

            const missingDocsForApp = missing_docs[app.application_id] || {
                verified_docs: [],
                missing_documents: [],
                not_applicable_docs: [],
                damaged_docs: [],
                other: []
            };

            // Initialize statuses for checklist documents
            checklist.forEach((item) => {
                if (missingDocsForApp.verified_docs?.includes(item)) {
                    initialSelectedValues[app.application_id][item] = "Verified";
                } else if (missingDocsForApp.missing_documents?.includes(item)) {
                    initialSelectedValues[app.application_id][item] = "Missing";
                } else if (missingDocsForApp.not_applicable_docs?.includes(item)) {
                    initialSelectedValues[app.application_id][item] = "N/A";
                } else if (missingDocsForApp.damaged_docs?.includes(item)) {
                    initialSelectedValues[app.application_id][item] = "Damaged";
                } else if (missingDocsForApp.other && missingDocsForApp.other.some(doc => doc.document === item)) {
                    initialSelectedValues[app.application_id][item] = "Other";
                } else {
                    initialSelectedValues[app.application_id][item] = "Verified";
                }
            });

            // Initialize statuses for additional documents
            const additionalDocuments = app.additional_document || [];
            additionalDocuments.forEach((doc) => {
                if (missingDocsForApp.verified_docs?.includes(doc)) {
                    initialSelectedValues[app.application_id][doc] = "Verified";
                } else if (missingDocsForApp.missing_documents?.includes(doc)) {
                    initialSelectedValues[app.application_id][doc] = "Missing";
                } else if (missingDocsForApp.not_applicable_docs?.includes(doc)) {
                    initialSelectedValues[app.application_id][doc] = "N/A";
                } else if (missingDocsForApp.damaged_docs?.includes(doc)) {
                    initialSelectedValues[app.application_id][doc] = "Damaged";
                } else if (missingDocsForApp.other && missingDocsForApp.other.some(d => d.document === doc)) {
                    initialSelectedValues[app.application_id][doc] = "Other";
                } else {
                    initialSelectedValues[app.application_id][doc] = "Verified";
                }
            });

            // Initialize all rows as unselected
            initialSelectedRows[app.application_id] = false;
        });

        setSelectedValues(initialSelectedValues);
        setSelectedRows(initialSelectedRows);
    }, [data.applications, checklistPLUSEC, checklistPLSEC, missing_docs]);

    const getChecklist = useCallback(
        (product) => {
            return product === "PL-USEC" ? checklistPLUSEC : checklistPLSEC;
        },
        [checklistPLUSEC, checklistPLSEC]
    );

    const handleDropdownChange = (appId, item, value) => {
        setSelectedValues((prevState) => {
            const updatedValues = {
                ...prevState,
                [appId]: {
                    ...prevState[appId],
                    [item]: value,
                },
            };

            // Check if any document other than "Declaration for damaged docs" is marked as "Damaged"
            const hasDamagedDocs = Object.entries(updatedValues[appId]).some(
                ([doc, status]) => doc !== "Declaration for damaged docs" && status === "Damaged"
            );

            // Automatically set "Declaration for damaged docs" to "Missing" if any document is marked as "Damaged"
            if (hasDamagedDocs) {
                updatedValues[appId]["Declaration for damaged docs"] = "Missing";
            } else {
                updatedValues[appId]["Declaration for damaged docs"] = "Verified";
            }

            return updatedValues;
        });
        setIsModified(true);
    };

    const handleOtherInputChange = (appId, item, value) => {
        setSelectedValues((prevState) => {
            const updatedValues = {
                ...prevState,
                [appId]: {
                    ...prevState[appId],
                    [`${item}_other`]: value,
                },
            };
            return updatedValues;
        });
    };

    const handleRowSelect = (record, appId) => {
        setSelectedRows((prevState) => {
            const isSelected = !prevState[appId];

            if (isSelected) {
                // Update all documents to "Verified"
                setSelectedValues((prevValues) => {
                    const updatedValues = { ...prevValues };
                    const appValues = updatedValues[appId];

                    // Iterate through all documents and set their status to "Verified"
                    Object.keys(appValues).forEach((doc) => {
                        if (!doc.includes('_other')) {
                            appValues[doc] = "Verified";
                        }
                    });

                    return updatedValues;
                });
            }

            return {
                ...prevState,
                [appId]: isSelected,
            };
        });
        setIsModified(true);
    };

    const handleSubmitMissingDocs = async () => {
        setLoading(true);

        const missingDocsJSON = Object.keys(selectedValues)
            .map((appId) => {
                if (!appId || !selectedValues[appId]) return null;

                // Only include rows with changes other than 'Verified'
                if (!selectedRows[appId]) {
                    const hasNonVerified = Object.entries(selectedValues[appId]).some(
                        ([key, value]) => !key.includes('_other') && value !== "Verified"
                    );
                    if (!hasNonVerified) return null;
                }

                const missingDocsForApp = {
                    application_id: appId,
                    missing_documents: [],
                    not_applicable_docs: [],
                    damaged_docs: [],
                    verified_docs: [],
                    other_docs: [],
                };

                // Process each document entry and its status
                Object.keys(selectedValues[appId]).forEach((doc) => {
                    if (doc.includes('_other')) return; // Skip the _other fields

                    const selectedValue = selectedValues[appId][doc];
                    if (selectedValue === "Verified") {
                        missingDocsForApp.verified_docs.push(doc);
                    } else if (selectedValue === "N/A") {
                        missingDocsForApp.not_applicable_docs.push(doc);
                    } else if (selectedValue === "Damaged") {
                        missingDocsForApp.damaged_docs.push(doc);
                    } else if (selectedValue === "Missing") {
                        missingDocsForApp.missing_documents.push(doc);
                    } else if (selectedValue === "Other") {
                        const otherValue = selectedValues[appId][`${doc}_other`];
                        if (otherValue) {
                            missingDocsForApp.other_docs.push({ document: doc, Remark: otherValue });
                        }
                    }
                });

                // Include only if there are changes in any category
                if (
                    missingDocsForApp.verified_docs.length > 0 ||
                    missingDocsForApp.missing_documents.length > 0 ||
                    missingDocsForApp.not_applicable_docs.length > 0 ||
                    missingDocsForApp.damaged_docs.length > 0 ||
                    missingDocsForApp.other_docs.length > 0
                ) {
                    return missingDocsForApp;
                }
                return null;
            })
            .filter(Boolean);

        const requestBody = {
            tracking_number: data.tracking_number,
            branch: data.branch,
            docs: missingDocsJSON,
        };

        // Execute the callback with the updated data
        if (onMissingDocs) {
            await onMissingDocs(requestBody);
            setIsModified(false);
        }

        setLoading(false);
    };

    const handleSelectChange = (appId, value) => {
        setAppStatus((prevState) => ({
            ...prevState,
            [appId]: value,
        }));

        if (value === 'Yes') {
            if (!receivedAppIds.includes(appId)) {
                setReceivedAppIds((prev) => [...prev, appId]);
            }
            setNotReceivedAppIds((prev) => prev.filter((id) => id !== appId));
        } else {
            setNotReceivedAppIds((prev) => [...prev, appId]);
            setReceivedAppIds((prev) => prev.filter((id) => id !== appId));
        }
    };

    const handleStampNoSubmit = async (application_id, tracking_number) => {
        const stampNo = stampNos[application_id];

        const pattern = /^[a-zA-Z0-9]+$/;
        if (!stampNo) {
            notification.warning({
                message: 'Warning',
                description: 'Please enter a stamp number before submitting.',
                placement: 'bottomRight',
            });
            return;
        }

        if (!pattern.test(stampNo)) {
            notification.error({
                message: 'Error',
                description: 'Stamp number must be alphanumeric!',
                placement: 'bottomRight',
            });
            return;
        }

        const requestBody = {
            application_id,
            stamp_no: stampNo,
            tracking_number: tracking_number
        };

        try {
            const response = await dispatch(postStampNo({ requestBody, jwtBearer }));

            if (response?.type === 'postStampNo/fulfilled') {
                notification.success({
                    message: 'Success',
                    description: response.payload.message,
                    placement: 'bottomRight'
                });

                // Update local dataSource
                setDataSource(prevData =>
                    prevData.map(record =>
                        record.application_id === application_id
                            ? { ...record, stamp_no: stampNo }
                            : record
                    )
                );

                // Refresh tracking details
                await refreshTrackingDetails();

                setStampNoChanged(false);
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Failed to update stamp number. Please try again.',
                    placement: 'bottomRight'
                });
            }
        } catch (error) {
            notification.error({
                message: 'Error',
                description: 'An error occurred while updating the stamp number.',
                placement: 'bottomRight'
            });
        }
    };

    const handleStampNoChange = (applicationId, value) => {
        setStampNoChanged(true);
        setStampNos(prevState => ({
            ...prevState,
            [applicationId]: value,
        }));
    };

    const handleMarkAsReceive = async () => {
        try {
            const requestBody = {
                received_ids: receivedAppIds,
                not_received_ids: notReceivedAppIds,
                type: 'forward'
            };

            const response = await dispatch(markAppIdRecieve({ jwtBearer, requestBody }));

            if (response?.payload?.message) {
                notification.success({
                    message: 'Success',
                    description: response.payload.message,
                    placement: 'bottomRight'
                });

                // Refresh tracking details
                await refreshTrackingDetails();
                onClose();
            }
        } catch (error) {
            notification.error({
                message: 'Submission Failed',
                description: 'An error occurred while updating application statuses.',
                placement: 'bottomRight'
            });
        }
    };

    // Add this function after the columns definition
const handleProductFilterReset = () => {
    setProductFilter(null);
};

    const columns = [
        ...(appIdStatus === '1' ? [
            {
                title: "Received",
                key: "received",
                render: (text, record) => (
                    <Select
                        value={appStatus[record.application_id] || "Yes"}
                        style={{ width: 80 }}
                        onChange={(value) => handleSelectChange(record.application_id, value)}
                    >
                        <Select.Option value="Yes">Yes</Select.Option>
                        <Select.Option value="No">No</Select.Option>
                    </Select>
                ),
            }
        ] : []),

        ...(appIdStatus !== '1' ? [
            {
                title: "Verification",
                dataIndex: "verification",
                key: "verification",
                render: (text, record) => {
                    const verification = record.verification;
                    const stampNo = record.stamp_no;

                    if (!stampNo) {
                        return (
                            <ExclamationCircleOutlined
                                style={{ color: "gray", fontSize: "28px" }}
                            />
                        );
                    }

                    // Check if any document for this record is marked as "Missing"
                    const hasMissingDocs = Object.entries(selectedValues[record.application_id] || {}).some(
                        ([key, value]) => !key.includes('_other') && value === "Missing"
                    );
                    const hasOtherDocs = Object.entries(selectedValues[record.application_id] || {}).some(
                        ([key, value]) => !key.includes('_other') && value === "Other"
                    );

                    // Display icons based on status
                    if (selectedRows[record.application_id]) {
                        return (
                            <CheckCircleFilled
                                style={{ color: "green", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    }

                    if (hasMissingDocs || hasOtherDocs) {
                        return (
                            <ExclamationCircleOutlined
                                style={{ color: "red", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    }

                    if (verification === "5") {
                        return (
                            <CheckCircleFilled
                                style={{ color: "green", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    } else if (verification === "4") {
                        return (
                            <RxCrossCircled
                                style={{ color: "grey", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    } else if (verification === "8") {
                        return (
                            <ExclamationCircleOutlined
                                style={{ color: "red", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    } else {
                        return (
                            <ExclamationCircleOutlined
                                style={{ color: "orange", fontSize: "28px", cursor: "pointer" }}
                                onClick={() => handleRowSelect(record, record.application_id)}
                            />
                        );
                    }
                },
            }
        ] : []),

        {
            title: "Application Id",
            dataIndex: "application_id",
            key: "application_id",
        },
        {
            title: "OXYZO ID",
            dataIndex: "partner_loan_id",
            key: "partner_loan_id",
        },
        {
            title: "NAME",
            dataIndex: "applicant_name",
            key: "applicant_name",
        },
       {
    title: "PRODUCT",
    dataIndex: "product",
    key: "product",
    filters: [
        { text: "PL-USEC", value: "PL-USEC" },
        { text: "PL-SEC", value: "PL-SEC" },
        { text: "PL-Suvidha", value: "PL-Suvidha" },
    ],
    onFilter: (value, record) => record.product === value,
    filteredValue: productFilter ? [productFilter] : null,
},
        ...(appIdStatus !== '1' ? [
            {
                title: "Manual Stamp No",
                dataIndex: "stamp_no",
                key: "stamp_no",
                render: (text, record) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input
                                defaultValue={record.stamp_no || ""}
                                onChange={(e) => handleStampNoChange(record.application_id, e.target.value)}
                                style={{ width: 150, marginRight: 8 }}
                            />
                            <Button
                                type="primary"
                                onClick={() => handleStampNoSubmit(record.application_id, record.tracking_number)}
                            >
                                {record.stamp_no ? 'Update' : 'Submit'}
                            </Button>
                        </div>
                    );
                },
            }
        ] : []),
    ];

    const handleButtonClick = () => {
        setIsInputVisible(true);
    };

    const handleInputChange = (e) => {
        setDocumentName(e.target.value);
    };

    const handleSubmitAdditionalDocs = async (record) => {
        setLoading(true);
        try {
            const requestBody = {
                application_id: record.application_id,
                document: documentName,
            };

            const response = await dispatch(addAdditionalDocuments({ requestBody, jwtBearer }));

            if (response?.type === 'addAdditionalDocuments/fulfilled') {
                notification.success({
                    message: 'Success',
                    description: response.payload.message,
                    placement: 'bottomRight',
                });

                // Update local dataSource
                setDataSource(prevDataSource => {
                    return prevDataSource.map(item =>
                        item.application_id === record.application_id
                            ? {
                                ...item,
                                additional_document: [
                                    ...(Array.isArray(item.additional_document) ? item.additional_document : []),
                                    documentName,
                                ],
                            }
                            : item
                    );
                });

                // Update selectedValues
                setSelectedValues(prevState => ({
                    ...prevState,
                    [record.application_id]: {
                        ...prevState[record.application_id],
                        [documentName]: "Verified",
                    },
                }));

                // Refresh tracking details
                await refreshTrackingDetails();

                setDocumentName("");
                setIsInputVisible(false);
            } else {
                notification.error({
                    message: 'Error',
                    description: 'Failed to add additional documents.',
                    placement: 'bottomRight',
                });
            }
        } catch (error) {
            console.error("Error submitting document:", error);
        } finally {
            setLoading(false);
        }
    };

    const receivedData = dataSource.filter(record => record.app_id_status !== '2');
    const filteredDataSource = dataSource.filter(record => record.app_id_status === "2");


    const handleSelectAppId = (value) => {
        setSelectedAppId(value);
    };

    const handleDeleteTempAppId = (key) => {
        const updatedAppIds = selectedAppIds.filter((appId) => appId !== key);
        setSelectedAppIds(updatedAppIds);
    };

const handleAddAppId = () => {
    if (selectedAppId && selectedAppId.length > 0) {
        const selectedApp = allAppIdData.find((item) => item.APP_ID === selectedAppId);

        if (selectedApp) {
            const formattedAppId = `${selectedApp.APP_ID} - ${selectedApp.APPLICANT_NAME} - ${selectedApp.PARTNER_LOAN_ID} - ${selectedApp.PRODUCT}`;
            setSelectedAppIds((prevArray) => [...prevArray, formattedAppId]);
            setReceivedAppIds((prevIds) => [...prevIds, selectedAppId]);
        }

        if (tableRef.current) {
            tableRef.current.scrollIntoView({ behavior: "smooth" });
        }

        setSelectedAppId(null);
    }
};

    const handleSaveAppIdsClick = async () => {
        const requestBody = {
            application_id: selectedAppIds,
            tracking_number: data.tracking_number,
        };

        setLoadingSave(true);

        try {
            await dispatch(updateHoAppId({ jwtBearer, requestBody }));

            notification.success({
                message: "Success",
                description: "Application ID(s) Added Successfully",
                placement: "bottomRight",
            });

            setSelectedAppIds([]);

            // Refresh tracking details
            await refreshTrackingDetails();
        } catch (error) {
            console.error("Error updating in-transit:", error);
            notification.error({
                message: "Error",
                description: "Failed to update application IDs",
                placement: "bottomRight",
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const handleDrawerClose = () => {
        if (isModified) {
            setOpenDialog(true);
        } else {
            onClose();
        }
    };

    const handleSaveAndClose = () => {
        handleSubmitMissingDocs();
        setOpenDialog(false);
    };

    const handleCancelAndClose = () => {
        setOpenDialog(false);
        onClose();
    };

    const getStatusText = (statusCode) => {
        switch (statusCode) {
            case "1": return "In-Transit";
            case "2": return "In-Query";
            case "3": return "Received";
            default: return "";
        }
    };

    const getVerificationText = (statusCode) => {
        switch (statusCode) {
            case "4": return "Pending at HO";
            case "5": return "Verified";
            case "8": return "Missing/Damaged Documents and Pending";
            default: return "";
        }
    };

    const handleProductFilterChange = (pagination, filters, sorter) => {
    // Update product filter state when filter changes
    if (filters && filters.product) {
        setProductFilter(filters.product[0]); // Take the first selected filter value
    } else {
        setProductFilter(null);
    }
};

    // const notReceivedColumns = [
    //     { title: "Application Id", dataIndex: "application_id", key: "application_id" },
    //     { title: "NAME", dataIndex: "applicant_name", key: "applicant_name" },
    //     { title: "OXYZO ID", dataIndex: "partner_loan_id", key: "partner_loan_id" },
    //     { title: "PRODUCT", dataIndex: "product", key: "product" },
    // ];

    const notReceivedColumns = [
    { title: "Application Id", dataIndex: "application_id", key: "application_id" },
    { title: "NAME", dataIndex: "applicant_name", key: "applicant_name" },
    { title: "OXYZO ID", dataIndex: "partner_loan_id", key: "partner_loan_id" },
    {
        title: "PRODUCT",
        dataIndex: "product",
        key: "product",
        filters: [
            { text: "PL-USEC", value: "PL-USEC" },
            { text: "PL-SEC", value: "PL-SEC" },
            { text: "PL-Suvidha", value: "PL-Suvidha" },
        ],
        onFilter: (value, record) => record.product === value,
    },
];

    return (
        <Drawer
            title={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Popover
                        content={`This courier has ${receivedData.length} number of Application ID (s).`}
                        title="Received"
                        trigger="hover"
                    >
                        <InfoCircleOutlined
                            style={{ marginRight: "8px", color: "#1890ff", fontSize: "28px" }}
                        />
                    </Popover>
                    <Title level={4} style={{ marginBottom: "16px", color: "rgba(0, 0, 0, 0.7)", fontSize: "20px", fontFamily: "Poppins", marginLeft: "5px" }}>
                        Courier details
                    </Title>
                </div>
            }
            visible={visible}
            onClose={handleDrawerClose}
            width={1120}
        >
            {myLoading ? (
                <div className="spinner-container">
                    <HashLoader color="#f57171" />
                </div>
            ) : (
                <div style={{ padding: "0 20px" }}>
                    {/* Status Section */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "0 8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between", height: "50px" }}>
                        <strong style={{ color: "#555" }}>Status :</strong>
                        <Text style={{ fontSize: "20px", fontFamily: "Poppins", backgroundColor: "green", padding: "0px 8px", color: "white", borderRadius: "6px" }}>
                            {getStatusText(data.status)}
                        </Text>
                    </Space>

                    {/* POD Number */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between" }}>
                        <strong style={{ color: "#555" }}>POD Number :</strong>
                        <Text style={{ fontSize: "18px", fontFamily: "Poppins", fontWeight: "800" }}>
                            {data.tracking_number}
                        </Text>
                    </Space>

                    {/* Vendor */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between" }}>
                        <strong style={{ color: "#555" }}>Vendor :</strong>
                        <Text style={{ fontSize: "18px", fontFamily: "Poppins", fontWeight: "800" }}>
                            {data.vendor}
                        </Text>
                    </Space>

                    {/* Verification */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between" }}>
                        <strong style={{ color: "#555" }}>Verification:</strong>
                        <Text>
                            {data?.verification === "8" ? (
                                <div style={{ display: "flex", flexDirection: "row", gap: "8px" }}>
                                    <button style={{ backgroundColor: "red", color: "white", padding: "8px", borderRadius: "4px", fontSize: "20px", fontFamily: "Poppins", border: "red solid 2px" }}>
                                        Missing/Damaged Documents
                                    </button>
                                    <button style={{ backgroundColor: "yellow", color: "black", padding: "8px", borderRadius: "4px", fontSize: "20px", fontFamily: "Poppins", border: "yellow solid 2px" }}>
                                        Pending
                                    </button>
                                </div>
                            ) : (
                                <Text style={{
                                    fontSize: "18px",
                                    fontFamily: "Poppins",
                                    backgroundColor: data.verification === "5" ? "green" : data.verification === "4" ? "orange" : "red",
                                    padding: "3px 8px",
                                    color: "white",
                                    borderRadius: "6px"
                                }}>
                                    {getVerificationText(data?.verification)}
                                </Text>
                            )}
                        </Text>
                    </Space>

                    {/* Branch */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between" }}>
                        <strong style={{ color: "#555" }}>Branch :</strong>
                        <Text style={{ fontSize: "18px", fontFamily: "Poppins" }}>
                            {data.branch}
                        </Text>
                    </Space>

                    {/* Dispatched By */}
                    <Space style={{ display: "flex", marginBottom: "8px", padding: "8px", borderRadius: "4px", backgroundColor: "#ffffff", boxShadow: "0 1px 3px rgba(0,0,0,0.1)", fontSize: "20px", fontFamily: "Poppins", justifyContent: "space-between" }}>
                        <strong style={{ color: "#555" }}>Dispatched by :</strong>
                        <Text style={{ fontSize: "18px", fontFamily: "Poppins" }}>
                            {data?.courier_dispatcher_name}
                        </Text>
                    </Space>

                    {productFilter && (
    <Button 
        size="small" 
        onClick={handleProductFilterReset}
        style={{ marginBottom: 8 }}
    >
        Clear Product Filter
    </Button>
)}


                    {/* Main Table */}
                    <MyStyledTable
                        columns={columns}
                        dataSource={receivedData}
                        pagination={{ pageSize: 6 }}
                        style={{ marginTop: "30px" }}
                        rowKey="application_id"
                            onChange={handleProductFilterChange}

                        expandable={
                            appIdStatus !== '1' && {
                                expandedRowRender: (record) => {
                                    if (!record.stamp_no) return null;

                                    const checklist = getChecklist(record.product);
                                    const additionalDocuments = record.additional_document || [];
                                    const allDocuments = [...checklist, ...additionalDocuments];

                                    const renderChecklistItems = allDocuments.map((item) => {
                                        const remarksForDoc = record.doc_details?.other?.filter(doc => doc.document === item) || [];
                                        const lastRemarkDoc = remarksForDoc.length > 0 ? remarksForDoc[remarksForDoc.length - 1] : null;
                                        const lastRemark = lastRemarkDoc?.Remark || "";

                                        return (
                                            <List.Item key={item}>
                                                <span style={{ marginRight: "20px", fontSize: "16px" }}>
                                                    {item}
                                                </span>
                                                {record.verification !== "5" && (
                                                    <Row gutter={8} align="middle">
                                                        {selectedValues[record.application_id]?.[item] === "Other" && (
                                                            <Col>
                                                                <Input
                                                                    value={selectedValues[record.application_id]?.[`${item}_other`] || lastRemark}
                                                                    onChange={(e) => handleOtherInputChange(record.application_id, item, e.target.value)}
                                                                    placeholder="Add remark here..."
                                                                    style={{ width: 300 }}
                                                                />
                                                            </Col>
                                                        )}
                                                        <Col>
                                                            <Select
                                                                value={selectedValues[record.application_id]?.[item] || "Verified"}
                                                                onChange={(value) => handleDropdownChange(record.application_id, item, value)}
                                                                style={{ width: 120 }}
                                                            >
                                                                <Select.Option value="Verified">Verified</Select.Option>
                                                                <Select.Option value="Missing">Missing</Select.Option>
                                                                <Select.Option value="Damaged">Damaged</Select.Option>
                                                                <Select.Option value="N/A">N/A</Select.Option>
                                                                <Select.Option value="Other">Other</Select.Option>
                                                            </Select>
                                                        </Col>
                                                    </Row>
                                                )}
                                            </List.Item>
                                        );
                                    });

                                    return (
                                        <div>
                                            <List
                                                size="small"
                                                bordered
                                                dataSource={[{ key: 'add-doc-button' }]}
                                                renderItem={() => (
                                                    <List.Item>
                                                        {record.verification !== "5" && isInputVisible && (
                                                            <>
                                                                <Input
                                                                    value={documentName}
                                                                    onChange={handleInputChange}
                                                                    placeholder="Enter document name"
                                                                    style={{ width: "80%", marginRight: "10px" }}
                                                                />
                                                                <Button
                                                                    type="primary"
                                                                    loading={loading}
                                                                    onClick={() => handleSubmitAdditionalDocs(record)}
                                                                    disabled={!documentName.trim()}
                                                                >
                                                                    Submit Document
                                                                </Button>
                                                            </>
                                                        )}
                                                        {record.verification !== "5" && !isInputVisible && (
                                                            <Button onClick={handleButtonClick}>Add additional documents</Button>
                                                        )}
                                                    </List.Item>
                                                )}
                                            />
                                            <List size="small" bordered dataSource={allDocuments}>
                                                {renderChecklistItems}
                                            </List>
                                        </div>
                                    );
                                },
                                expandIcon: ({ expanded, onExpand, record }) =>
                                    expanded ? (
                                        <IoIosArrowDropup onClick={(e) => onExpand(record, e)} style={{ fontSize: "20px", height: "20px" }} />
                                    ) : (
                                        <IoIosArrowDropdown onClick={(e) => onExpand(record, e)} style={{ fontSize: "20px", height: "20px" }} />
                                    ),
                            }
                        }
                    />

                    {/* Submit Button */}
                    {data.verification !== "5" && isModified && (
                        <Popconfirm
                            title="Are you sure you want to submit the changes?"
                            onConfirm={handleSubmitMissingDocs}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button type="primary" loading={loading} style={{ marginTop: 2 }}>
                                Submit
                            </Button>
                        </Popconfirm>
                    )}

                    {/* Missing Application IDs */}
                    {filteredDataSource.length > 0 && (
                        <>
                            <h2 style={{ margin: "30px 0" }}>Missing Application Id(s)</h2>
                            <MyStyledTable
                                columns={notReceivedColumns}
                                dataSource={filteredDataSource}
                                pagination={false}
                                rowKey="application_id"
                            />
                        </>
                    )}

                    {/* Mark as Received */}
                    {appIdStatus === '1' && (
                        <Popconfirm
                            title="Are you sure you want to submit the changes?"
                            onConfirm={handleMarkAsReceive}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button type="primary" loading={loading} style={{ marginTop: 20 }}>
                                Submit
                            </Button>
                        </Popconfirm>
                    )}

                    {/* Add New Application IDs */}
                {/* Add New Application IDs */}
{appIdStatus === '1' && (
    <div style={{ padding: "16px 0", backgroundColor: "#f9f9f9", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginTop: "30px", margin: "20px 25px" }}>
        <h2 style={{ margin: "15px 30px" }}>
            Add {selectedAppIds.length > 0 && selectedAppIds.length} New Application ID(s)
        </h2>
        
        <Space style={{ marginTop: "8px", width: "100%", margin: "15px 30px", marginLeft: "5px" }}>
            <Select
                showSearch
                value={selectedAppId}
                onChange={handleSelectAppId}
                onDropdownVisibleChange={handleDropdownOpen} // Add this line
                placeholder="Select Application ID"
                style={{ flex: 1, minWidth: "400px", height: "40px" }}
                loading={applicationsLoading} // Shows loading spinner in select
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={
                    applicationsLoading ? (
                        <div style={{ padding: '10px', textAlign: 'center' }}>
                            Loading applications...
                        </div>
                    ) : (
                        <div style={{ padding: '10px', textAlign: 'center' }}>
                            {selectOptionsLoaded && availableAppIDs.length === 0 
                                ? 'No applications available' 
                                : 'Click to load applications'}
                        </div>
                    )
                }
            >
                {availableAppIDs
                    .filter((app) => !selectedAppIds.includes(`${app.APP_ID} - ${app.APPLICANT_NAME} - ${app.PARTNER_LOAN_ID} - ${app.PRODUCT}`))
                    .map((app) => (
                        <Option key={app.APP_ID} value={app.APP_ID}>
                            {`${app.APP_ID} - ${app.APPLICANT_NAME} - ${app.PRODUCT}`}
                        </Option>
                    ))}
            </Select>

            {selectedAppId ? (
                <Button 
                    onClick={handleAddAppId} 
                    type="dashed" 
                    icon={<PlusOutlined />} 
                    style={{ border: "2px solid dodgerblue" }}
                >
                    Add
                </Button>
            ) : (
                <Button type="primary" icon={<PlusOutlined />} disabled>
                    Add
                </Button>
            )}

            {selectedAppIds.length > 0 && (
                <Button onClick={handleSaveAppIdsClick} type="primary" loading={loadingSave}>
                    Save Changes
                </Button>
            )}
        </Space>

        {selectedAppIds.length > 0 && (
            <MyDetailedStyledTempTable
                bordered
                dataSource={selectedAppIds.map((appId) => ({ key: appId, appId: appId }))}
                pagination={selectedAppIds.length > 5 ? { pageSize: 5 } : false}
                columns={[
                    { dataIndex: "appId", render: (text) => text || "" },
                    {
                        render: (text, record) => (
                            <DeleteOutlined 
                                onClick={() => handleDeleteTempAppId(record.key)} 
                                style={{ color: "red", cursor: "pointer" }} 
                            />
                        ),
                    },
                ]}
                showHeader={false}
            />
        )}
    </div>
)}
                </div>
            )}

            {/* Confirmation Dialog */}
            <Modal
                visible={openDialog}
                title="Unsaved Changes"
                onOk={handleSaveAndClose}
                onCancel={handleCancelAndClose}
                cancelText="Don't Save"
                okText="Save Changes"
                centered
            >
                <Text>Do you want to save ?</Text>
            </Modal>
        </Drawer>
    );
};

export default AfterReceivedHo;